
import React, { useEffect, useRef, useState } from "react";
import { LuRedo2, LuUndo2 } from "react-icons/lu";
import { MdClose } from "react-icons/md";
import { ReactSketchCanvas } from "react-sketch-canvas";

const Draw = ({ show, setshowDraw, drawingsRef }) => {

    const canvasRef = useRef(null);

    const [color, setcolor] = useState("#ff0000");
    const [selectSize, setselectSize] = useState(3);

    async function savePage() {
        if (!canvasRef.current) return;
        
        drawingsRef.current[show] = await canvasRef.current.exportPaths();
    }

    async function loadPage() {
        if (!canvasRef.current) return;

        const paths = drawingsRef.current[show];
        if (paths) {
            await canvasRef.current.loadPaths(paths);
        }
    }

    useEffect(() => {
        loadPage(show);
    }, [])
    
    if (!show) return;
    

    return (
        <div style={{ position: "absolute", zIndex:8, width: "100%", height: "100%", display: show ? "block" : "none" }}>
            
            <div className="drawToolbarBox">
                <ul>
                    <label style={{backgroundColor:color}}>
                        <input type='color' value={color} onChange={(e) => setcolor(e?.target?.value)} name='color' />
                    </label>
                </ul>

                <ul>
                    <a className={selectSize == 3 ? `check` : null} onClick={() => setselectSize(3)}>
                        <span />
                    </a>
                    <a className={selectSize == 8 ? `check` : null} onClick={() => setselectSize(8)}>
                        <span style={{width:12}} />
                    </a>
                    <a className={selectSize == 16 ? `check` : null} onClick={() => setselectSize(16)}>
                        <span style={{width:16}} />
                    </a>
                </ul>

                <ul>
                    <a onClick={() => canvasRef.current.redo()}>
                        <LuUndo2 />
                    </a>
                    <a onClick={() => canvasRef.current.undo()}>
                        <LuRedo2 />
                    </a>
                </ul>

                <ul>

                    <a onClick={() => setshowDraw(false)} style={{backgroundColor:"#ff4545"}}>
                        <MdClose color="#fff" />
                    </a>
                    
                </ul>
            </div>

            {/* Overlay sketch canvas */}
            <ReactSketchCanvas
                ref={canvasRef}
                onStroke={savePage}
                width="100%"
                height="100%"
                className="canvasDrawPos"
                strokeWidth={selectSize}
                strokeColor={color}
                canvasColor="transparent"
                style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                }}
            />

        </div>
    );
};

export default Draw;
